import { render, staticRenderFns } from "./WeekendAndHolidayDocument.vue?vue&type=template&id=358a5d38&scoped=true"
import script from "./WeekendAndHolidayDocument.vue?vue&type=script&lang=js"
export * from "./WeekendAndHolidayDocument.vue?vue&type=script&lang=js"
import style0 from "./WeekendAndHolidayDocument.vue?vue&type=style&index=0&id=358a5d38&prod&scoped=true&lang=css"
import style1 from "./WeekendAndHolidayDocument.vue?vue&type=style&index=1&id=358a5d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358a5d38",
  null
  
)

export default component.exports